import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class EbRecruiterItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            contactFormNode: '.m-ebRecruiterItem__contactFormNode',
            name: '.m-ebRecruiterItem__name',
            avatar: '.m-ebRecruiterItem__avatar',
            position: '.m-ebRecruiterItem__position',
            telephone: '.m-ebRecruiterItem__phone',
            quote: '.m-ebRecruiterItem__description',
            agp: '.m-ebRecruiterItem__agp',
        };
    }

    getPropsFromDom() {
        return {
            showMore: false,
            theme: true,
            imgSrc: this.dom.avatar?.src ?? '',
            name: this.dom.name?.innerHTML ?? '',
            telephone: this.dom.telephone?.innerHTML ?? '',
            position: this.dom.position?.innerHTML ?? '',
            quote: this.dom.quote?.innerHTML ?? '',
            recruiterEmail: this.dom.contactFormNode?.getAttribute('data-recruiter-email') ?? false,
            userEmail: this.dom.contactFormNode?.getAttribute('data-user-email') ?? false,
            userFirstName: this.dom.contactFormNode?.getAttribute('data-user-firstname') ?? false,
            userSurName: this.dom.contactFormNode?.getAttribute('data-user-surname') ?? false,
        };
    }

    domEvents() {
        if (this.dom.contactFormNode) {
            this.dom.contactFormNode.addEventListener('click', () => this.openInquiryModal());
        }
    }

    openInquiryModal() {
        this.events.emit('openInquiryModal', this.props);
    }

    ready() {
        this.addViewportObserver();
    }

    entersViewport() {
        if (this.dom.avatar) {
            this.events.emit('updateRecruiterItemProps');
        }
    }

    afterRender() {
        if (window.self !== window.parent) {
            this.events.emit('updateIFrame');
        }
    }
}
